/** Workspace remains responsible for authorizing the destination. */
/** @param {string | null | undefined} issuer @param {string} path */
export function workspaceManagementUrl(issuer, path) {
  try {
    const source = new URL(issuer || "");
    if (!["https:", "http:"].includes(source.protocol)) return undefined;
    return new URL(path, source.origin).href;
  } catch {
    return undefined;
  }
}
